module.exports = __webpack_public_path__ + "static/media/icon6.430924c1.png";